<title>{{title}}</title>
<app-main [isAuth]="isAuth" style="height: 100%;"></app-main>

<div class="loading" *ngIf="isRouteLoading">
    <mat-progress-bar class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
    <!-- <img src="assets/images/Logo_Post&Work_(blanc).svg"> -->
</div>

<div class="splashScreen" [@splashScreen]="visibleSplashScreen ? 'show' : 'hide'"
    (@splashScreen.done)="onAnimationEvent($event)">
    <!-- <img src="assets/images/Logo_Post&Work_(couleur).svg"> -->
    <mat-spinner color="primary"></mat-spinner>
    <h3>
        {{ 'shared.label.loading' | translate }}
    </h3>
</div>